import React from 'react';
import { Input } from '../../../../components/input';
import { Select } from '../../../../components/select';
import { DateOfBirthField } from '../../../../components/date-of-birth-field';
import editIcon from '../../../../../assets/icons/edit.png';
import { NO_WRAP_FIELDS, CLOSE_TO_COLON_FIELDS, READONLY_FIELDS } from '../constants';
import { SegmentOption } from '../types';

interface EditableFieldProps {
  icon: any;
  label: string;
  value: string;
  fieldName: string;
  type?: 'text' | 'email' | 'date' | 'select';
  options?: SegmentOption[];
  mask?: string;
  maxLength?: number;
  rawValue?: any;
  showLabel?: boolean;
  isSegment?: boolean;
  allowEmpty?: boolean;
  isEditing: boolean;
  editingValue: any;
  loading: boolean;
  onStartEdit: (field: string, value: any) => void;
  onSave: (field: string, value: any) => void;
  onCancel: () => void;
  onValueChange: (value: any) => void;
}

export const EditableField: React.FC<EditableFieldProps> = ({
  icon,
  label,
  value,
  fieldName,
  type = 'text',
  options,
  mask,
  maxLength,
  rawValue,
  showLabel = true,
  isSegment = false,
  allowEmpty = true,
  isEditing,
  editingValue,
  loading,
  onStartEdit,
  onSave,
  onCancel,
  onValueChange
}) => {
  const shouldNoWrap = NO_WRAP_FIELDS.includes(fieldName);
  const shouldCloseToColon = CLOSE_TO_COLON_FIELDS.includes(fieldName);
  const isReadonly = READONLY_FIELDS.includes(fieldName);

  if (isEditing) {
    return (
      <div className='field-row editing' data-segment={isSegment ? 'true' : undefined}>
        {icon && <img src={icon} alt={label} className='field-icon' />}
        <div className='edit-controls'>
          {showLabel && <span className='field-label'>{label}:</span>}
          {type === 'select' && options ? (
            <Select
              name={fieldName}
              options={options}
              value={editingValue}
              onChange={onValueChange}
              allowEmpty={allowEmpty}
            />
          ) : type === 'date' && fieldName === 'date_of_birth' ? (
            <DateOfBirthField
              name={fieldName}
              value={editingValue}
              onChange={onValueChange}
              errors={[]}
            />
          ) : (
            <Input
              name={fieldName}
              type={type}
              value={editingValue}
              mask={mask}
              maxLength={maxLength}
              onChange={onValueChange}
            />
          )}
          <div className='edit-actions'>
            <button 
              className='save-btn' 
              onClick={() => onSave(fieldName, editingValue)}
              disabled={loading}
            >
              Salvar
            </button>
            <button 
              className='cancel-btn' 
              onClick={onCancel}
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='field-row' data-segment={isSegment ? 'true' : undefined}>
      {icon && <img src={icon} alt={label} className='field-icon' />}
      <div 
        className='field-content' 
        data-close-colon={shouldCloseToColon ? 'true' : undefined}
        data-readonly={isReadonly ? 'true' : undefined}
      >
        {showLabel && <span className='field-label'>{label}:</span>}
        <span 
          className={`field-value ${isReadonly ? 'readonly' : ''}`}
          data-no-wrap={shouldNoWrap ? 'true' : undefined}
          style={shouldNoWrap ? { whiteSpace: 'nowrap' } : {}}
        >
          {value || '-'}
        </span>
      </div>
      {!isReadonly && (
        <img 
          src={editIcon} 
          alt='edit' 
          className='edit-icon' 
          onClick={() => onStartEdit(fieldName, rawValue !== undefined ? rawValue : value)}
        />
      )}
    </div>
  );
};
